import PerfectScrollbar from "../vendors/perfect-scrollbar-1.4/dist/perfect-scrollbar.esm";
import { onDomReady } from "./utils";

(function(document, window, onDomReady, undefined) {
	onDomReady(function() {
		document.querySelectorAll('.scrollable').forEach(s => {
			new PerfectScrollbar(s);
		});
	});
})(document, window, onDomReady);